export const EVENT_CATEGORY = "Banner";
export const MODULE = "derby_banner";

export const EVENTS = {
  BANNER_LINK_CLICKED: "Banner Link Clicked",
  BANNER_VIEWED: "Banner Viewed"
};
